import { WIX_FORMS, CUSTOM_LOGIN } from '@wix/app-definition-ids';
export const CMS_APP_ID = 'dataBinding';
export const WIX_CODE_APP_ID = 'wix-code';
export let MembersWidgetAppId = /*#__PURE__*/function (MembersWidgetAppId) {
  MembersWidgetAppId[MembersWidgetAppId["SignUp"] = WIX_FORMS] = "SignUp";
  MembersWidgetAppId[MembersWidgetAppId["SignIn"] = CUSTOM_LOGIN] = "SignIn";
  return MembersWidgetAppId;
}({});
export let MembersCustomPageManagedByWixAppId = /*#__PURE__*/function (MembersCustomPageManagedByWixAppId) {
  MembersCustomPageManagedByWixAppId["SignUp"] = "5f4fa4f1-5afd-4ac0-8a85-e5ac1d2b9b7d";
  MembersCustomPageManagedByWixAppId["SignIn"] = "bbe1406a-31f5-4f3f-9e0a-b39dfd25274f";
  return MembersCustomPageManagedByWixAppId;
}({});
export const DEFAULT_BRANCH_ID = '00000000-0000-0000-0000-000000000000';

// Referral pages - excluded from scan until properly QA'd
// See: WIXSEO-1892
export const WIX_REFERRALS_APP_DEF_ID = '58be0514-fc10-4eb1-886e-2909d18f33b3';
export const WIX_REFERRALS_TPA_PAGE_IDS = ['wix-referrals-refer-friend', 'wix-referrals-referral'];

// Pricing Plans checkout-flow system pages - excluded from scan. They are
// flow-gated (need a selected plan's `planId` / a completed order) and can't
// render standalone in a headless scan, so they always fail. WIXSEO-4223.
export const WIX_PRICING_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const WIX_PRICING_PLANS_SYSTEM_TPA_PAGE_IDS = ['Plan Customization', 'Thank You', 'Paywall'];
//# sourceMappingURL=consts.js.map